export default __webpack_public_path__ + "static/media/img-banner03.0fb8a400.png";